import { render, staticRenderFns } from "./MessageToManagerModal.vue?vue&type=template&id=70180590&scoped=true&"
import script from "./MessageToManagerModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./MessageToManagerModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70180590",
  null
  
)

export default component.exports